let isMenuOpened = false;
let isCartOpened = false;
let isCartNotificationOpened = false;
let isNotificationOpened = false;
let cartNotificationTL;

const headerAnimation = (toggler, duration, stagger) => {
  const headerEasing = CustomEase.create('headerEasing', '0.40, 0, 0.2, 1.');
  const header = $('.header-parent');
  const headerLinedNotification = header.find('.header-lined-notification');
  const headerLogo = header.find('.logo-parent');
  const headerNavsParent = header.find('.header-navs');
  const headerNavs = headerNavsParent.find('.nav-list');
  const leftNavs = headerNavs.eq(isDesktop() ? 0 : 2).find('.nav-item');
  const rightNavs = headerNavs.eq(isDesktop() ? 1 : 3).find('.nav-item');

  const toY = toggler ? 0 : -header.outerHeight();
  const toOpacity = toggler ? 1 : 0;

  const headerTL = gsap.timeline({ paused: true });

  headerTL.add(
    gsap.to(headerLinedNotification, {
      y: toY,
      opacity: toOpacity,
      duration: duration,
      ease: 'headerEasing',
      overwrite: 'auto',
    }), 0
  );
  headerTL.add(
    gsap.to(headerLogo, {
      y: toY,
      opacity: toOpacity,
      duration: duration,
      ease: 'headerEasing',
      overwrite: 'auto',
    }), 0
  );
  headerTL.add(
    gsap.to(leftNavs, {
      y: toY,
      opacity: toOpacity,
      duration: duration,
      ease: 'headerEasing',
      stagger: {
        each: stagger,
        from: 'end',
      },
      overwrite: 'auto',
    }),
    stagger
  );
  headerTL.add(
    gsap.to(rightNavs, {
      y: toY,
      opacity: toOpacity,
      duration: duration,
      ease: 'headerEasing',
      stagger: {
        each: stagger,
        from: 'start',
      },
      overwrite: 'auto',
    }),
    stagger
  );

  return headerTL;
};

const debounce = (fn, wait = 100) => {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn(...args), wait);
  };
};

let $header, $headerLinedNotificationBgs,$headerNav, $navBgFirst, $navBgSecond, $logoOverflows, $sections;
let activeTriggers = [];
let headerMetrics = { headerHeight: 0, navHeight: 0, navOffset: 0, progressNavOffset: 0, progressNavRatio: 0 };

const cacheHeaderSelectors = () => {
  $header = $('header');
  $headerLinedNotificationBgs = $header.find('.header-lined-notification-bg');
  $headerNav = $header.find('> .header-nav-panel .header-navs .nav-item.link');
  $navBgFirst = $header.find('> .header-nav-panel .header-navs .nav-item-link-bg-first');
  $navBgSecond = $header.find('> .header-nav-panel .header-navs .nav-item-link-bg-second');
  $logoOverflows = $header.find('.logo-full-overflow');
  $sections = $('section:not(.shopify-pc__banner__dialog)');
}

const updateHeaderMetrics = () => {
  headerMetrics.navHeight = $navBgFirst.outerHeight() || 0;
  headerMetrics.headerHeight = $header.outerHeight(true) || 1;
  headerMetrics.navOffset = (headerMetrics.headerHeight - headerMetrics.navHeight) / 2;
  headerMetrics.progressNavOffset = headerMetrics.navOffset / headerMetrics.headerHeight;
  headerMetrics.progressNavRatio = headerMetrics.navHeight / headerMetrics.headerHeight;
};

const hasBg = ($el) => {
  if (!$el || $el.length === 0) return false;
  const bg = $el.css('background-color');
  return !(bg === 'rgba(0, 0, 0, 0)' || bg === 'transparent' || bg === '');
};

const buildHeaderTimeline = (isLight) => {
  const fromRatio = isLight ? 0 : 2;
  const toRatio = isLight ? 2 : 0;
  const { progressNavOffset, progressNavRatio } = headerMetrics;

  const tl = gsap.timeline({ paused: true });

  tl.add(gsap.fromTo($navBgFirst, { x: 0 }, { x: 0, duration: progressNavOffset }), 0);
  tl.add(gsap.fromTo($navBgFirst, { y: `${fromRatio * 50}%` }, { y: `-${toRatio * 50}%`, duration: progressNavRatio }), progressNavOffset);
  tl.add(gsap.fromTo($navBgSecond, { y: `${toRatio * 50}%` }, { y: `-${fromRatio * 50}%`, duration: progressNavRatio }), progressNavOffset);
  tl.add(gsap.fromTo($navBgFirst, { x: 0 }, { x: 0, duration: progressNavOffset }), progressNavOffset + progressNavRatio);
  tl.add(elementTransition($logoOverflows, fromRatio, toRatio).play(), 0);
  $headerLinedNotificationBgs.length != 0 ? tl.add(elementTransition($headerLinedNotificationBgs, fromRatio, toRatio).play(), 0) : false;

  return tl;
};

const createHeaderTriggers = () => {
  activeTriggers.forEach(t => t.kill && t.kill());
  activeTriggers = [];

  const sectionsArr = gsap.utils.toArray($sections);
  if (!sectionsArr.length) return;

  const lightFlags = sectionsArr.map((el) => {
    const $sec = $(el);
    const $secBg = $sec.find('.section-bg');
    return $secBg.length ? hasBg($secBg) : hasBg($sec);
  });

  const initialIsLight = !!lightFlags[0];
  $headerNav.data('is-light', `${initialIsLight}`);
  buildHeaderTimeline(initialIsLight).progress(1);

  sectionsArr.forEach((el, idx) => {
    if (idx === 0) return;

    const prev = !!lightFlags[idx - 1];
    const curr = !!lightFlags[idx];

    if (prev === curr) return;

    const tl = buildHeaderTimeline(curr);

    const trig = ScrollTrigger.create({
      trigger: el,
      start: 'top top+=11.556%',
      end: 'top top',
      scrub: true,
      animation: tl,
      onEnter: () => $headerNav.data('is-light', `${curr}`),
      onEnterBack: () => $headerNav.data('is-light', `${curr}`),
      onLeave: () => $headerNav.data('is-light', `${prev}`),
      onLeaveBack: () => $headerNav.data('is-light', `${prev}`),
    });

    activeTriggers.push(trig);
  });
};

const initHeaderTransitions = () => {
  updateHeaderMetrics();
  createHeaderTriggers();
};

const debouncedInit = debounce(() => {
  activeTriggers.forEach(t => t.kill && t.kill());
  activeTriggers = [];
  updateHeaderMetrics();
  createHeaderTriggers();
}, 150);

$(window).on('resize', debouncedInit);

$(document).ready(() => {
  //cacheHeaderSelectors();
  //initHeaderTransitions();
});


$(window).on('load', function () {
  lenis.on('scroll', ({ direction }) => {
    if (direction !== currentDirection) {
      currentDirection = direction;
      if (direction === 1 && !isMenuOpened && !isCartOpened && !isNotificationOpened) {
        headerAnimation(false, 0.4, 0.01).play();
      } else if (direction == -1) {
        headerAnimation(true, 0.4, 0.01).play();
      }
    }
  });
  setTimeout(function(){
    cacheHeaderSelectors();
    initHeaderTransitions();
  }, 100)
});
